import app from 'flarum/forum/app';
import { normalizeQuests, questIsExpired } from '../common/quests';

/**
 * Forum-side accessors over the public arenaQuestsEnabled/arenaQuests
 * attributes (see the Settings extender in extend.php) and the owner-only
 * arenaQuestProgress attribute (see Api\UserResourceFields) — mirrors
 * battlePass.ts's split between forum.attribute() config and per-user data.
 */

export function questsEnabled() {
  return app.forum.attribute('arenaQuestsEnabled') === true;
}

/**
 * Every active, admin-configured quest — empty when the feature is off.
 * Past-deadline quests (see Quest['deadline']'s docblock) are excluded the
 * same as inactive ones — they disappear from the modal for players even
 * though the admin editor still shows them (an admin can push the deadline
 * back out to bring one back).
 */
export function activeQuests() {
  if (!questsEnabled()) return [];
  return normalizeQuests(app.forum.attribute('arenaQuests')).filter(q => q.is_active && !questIsExpired(q));
}

/** Owner-only — null (empty map) for anyone viewing someone else's profile. */
export function questProgressFor(user) {
  return user?.attribute('arenaQuestProgress') ?? {};
}

/** "Жетоны" (Tokens) wallet balance — part of the public arenaStats attribute. */
export function questTokens(user) {
  const stats = user?.attribute('arenaStats');
  return stats?.tokens ?? 0;
}

/**
 * Admin-authored title if set, otherwise an auto-generated description from
 * the quest's type/target/config — same fallback idea as arenaButtons()'s
 * defaultTextKey, so an admin who never fills in "Название" still gets a
 * readable quest list.
 */
export function questTitle(quest) {
  if (quest.title.trim()) return quest.title;
  const target = String(quest.target);
  if (quest.type === 'play_card') {
    const card = quest.config.cardName || `#${quest.config.card_id ?? 0}`;
    return app.translator.trans('forumaker-arena.forum.quests.desc_play_card', {
      card,
      target
    });
  }
  return app.translator.trans(`forumaker-arena.forum.quests.desc_${quest.type}`, {
    target
  });
}